var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCouponSidebarIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2766_4012)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 7V25",
    stroke: "#808191",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 20.8988C3.00024 20.6684 3.07998 20.4453 3.22573 20.2669C3.37149 20.0886 3.57434 19.9661 3.8 19.92C4.70423 19.7364 5.51718 19.2458 6.1011 18.5314C6.68502 17.817 7.00401 16.9227 7.00401 16C7.00401 15.0773 6.68502 14.183 6.1011 13.4686C5.51718 12.7542 4.70423 12.2636 3.8 12.08C3.57434 12.0339 3.37149 11.9114 3.22573 11.7331C3.07998 11.5547 3.00024 11.3316 3 11.1012V8C3 7.73478 3.10536 7.48043 3.29289 7.29289C3.48043 7.10536 3.73478 7 4 7H28C28.2652 7 28.5196 7.10536 28.7071 7.29289C28.8946 7.48043 29 7.73478 29 8V11.1012C28.9998 11.3316 28.92 11.5547 28.7743 11.7331C28.6285 11.9114 28.4257 12.0339 28.2 12.08C27.2958 12.2636 26.4828 12.7542 25.8989 13.4686C25.315 14.183 24.996 15.0773 24.996 16C24.996 16.9227 25.315 17.817 25.8989 18.5314C26.4828 19.2458 27.2958 19.7364 28.2 19.92C28.4257 19.9661 28.6285 20.0886 28.7743 20.2669C28.92 20.4453 28.9998 20.6684 29 20.8988V24C29 24.2652 28.8946 24.5196 28.7071 24.7071C28.5196 24.8946 28.2652 25 28 25H4C3.73478 25 3.48043 24.8946 3.29289 24.7071C3.10536 24.5196 3 24.2652 3 24V20.8988Z",
    stroke: "#808191",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2766_4012"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCouponSidebarIcon);
export default __webpack_public_path__ + "static/media/coupon_sidebar_icon.536bdfe7fe7b36e98e892cf6c021caef.svg";
export { ForwardRef as ReactComponent };